enum TabsId {
  WhoWeAre,
  OurSolution,
  Files,
  LiveStreams
}

export default TabsId;
